var currentMediaImage;

var mediaGalleryElement;
var mediaGalleryCloseFullScreenButton;
var mediaGalleryLargeImageContainer;
var mediaGalleryCurrentIndex;
var mediaGalleryMaxIndex;
var mediaGalleryFirstActiveItem;
var largeImageOffset;
var mediaGalleryMaxOffset;
var mediaCurrentVariantSku;
var currentMediaImageBigSrc;
var mediaZoomBoxElement;
var mediaZoomBoxElementContainer;
var mediaItemCode;

var mediaMasterBody;
let mobileProductInfoNodes = [];
let mobileProductInfoTarget;
const mobileProductInfoBreakpoint = window.matchMedia(
  '(max-width: 1199px)',
);

var inFullScreenMode = false;
var mediaGalleryLargeZoomLoaded = false;

function nwMediaGalleryWireUpEvents(event) {
  mediaMasterBody = document.querySelector('body');
  mediaZoomBoxElement = document.querySelector(
    '.pdp-media-gallery-zoomBox-output-img',
  );
  mediaZoomBoxElementContainer = document.querySelector(
    '.pdp-media-gallery-zoomBox-output',
  );
  currentMediaImages = document.querySelectorAll(
    '.pdp-media-gallery-v3-container img',
  );
  mediaGalleryElement = document.querySelector(
    '.product__media-wrapper',
  );
  mediaGalleryCloseFullScreenButton = document.querySelector(
    '.pdp-media-gallery-v3-close',
  );
  mediaGalleryLargeImageContainer = document.querySelector(
    '.pdp-media-gallery-v3-container .product__media-gallery',
  );
  allProductMiniImages = document.getElementsByClassName(
    'product-mini-image',
  );
  bundleValue = document.querySelector(
    'input[name="mediaGalleryHiddenBundleType"][type="hidden"]',
  );

  //console.log("bundleValue = " + bundleValue);
  if (bundleValue != null) {
    MediaGalleryV3FilterImages('BUNDLE');
  }

  var mediaPrimaryContainer = document.querySelector(
    '.pdp-media-gallery-v3-container',
  );
  //disclaimerIcon.addEventListener("click",  function(){ toggleDisclaimerTextBlock(true, disclaimerTextBlock, parentToAppendTo) });

  for (var i = 0; i < allProductMiniImages.length; i++) {
    var nextLargeMediaImage = currentMediaImages[i];
    //nextLargeMediaImage.addEventListener("mouseenter",  nwMediaUpdateZoomBoxEnter );
    //nextLargeMediaImage.addEventListener("mousemove",  nwMediaUpdateZoomBox );
    //nextLargeMediaImage.addEventListener("mouseleave",  nwMediaUpdateZoomBoxLeave );

    nextLargeMediaImage.addEventListener('click', handleClickImage);
  }

  mediaGalleryCloseFullScreenButton.addEventListener(
    'touchend',
    handleTouchEndTapCloseButton,
  );
  mediaGalleryCloseFullScreenButton.addEventListener(
    'click',
    handleClickCloseButton,
  );

  mediaPrimaryContainer.addEventListener(
    'touchstart',
    swipeStartHandler,
  );
  mediaPrimaryContainer.addEventListener(
    'touchmove',
    swipeCurrentHandler,
  );
  mediaPrimaryContainer.addEventListener('touchend', swipeEndHandler);

  for (var i = 0; i < allProductMiniImages.length; i++) {
    var nextProductMiniImage = allProductMiniImages[i];
    nextProductMiniImage.addEventListener(
      'click',
      function () {
        ProductMiniImagesClicked(this);
      },
      false,
    );
  }

  mediaGalleryCurrentIndex = 0;

  MediaGalleryUpdateResize();

  UpdateLargeImageShown();
}

function SetupMobileProductInfoMove() {
  const productSection = document.querySelector(
    '[id^="MainProduct-"]',
  );

  if (productSection == null) return;

  mobileProductInfoTarget = productSection.querySelector(
    '[data-mobile-product-info-target]',
  );

  if (mobileProductInfoTarget == null) return;

  const titleNode =
    productSection.querySelector(
      '.product__info-wrapper .product-title-container',
    ) ||
    productSection.querySelector(
      '[data-mobile-product-info-target] .product-title-container',
    );
  const priceNode =
    productSection.querySelector(
      '.product__info-wrapper .price-row-container',
    ) ||
    productSection.querySelector(
      '[data-mobile-product-info-target] .price-row-container',
    );
  const productActionsDesktopTarget = productSection.querySelector(
    '[data-desktop-actions-target]',
  );
  const productActionsNode =
    productSection.querySelector(
      '.product__info-wrapper .product__title-right[data-product-actions-node]',
    ) ||
    productSection.querySelector(
      '[data-desktop-actions-target] .product__title-right[data-product-actions-node]',
    );
  const nodesToMove = [titleNode, priceNode];

  mobileProductInfoNodes = [];

  for (const node of nodesToMove) {
    if (node == null) continue;

    mobileProductInfoNodes.push({
      node: node,
      homeParent: node.parentNode,
      homeNextSibling: node.nextSibling,
    });
  }

  if (
    productActionsNode != null &&
    productActionsDesktopTarget != null
  ) {
    mobileProductInfoNodes.push({
      node: productActionsNode,
      homeParent: productActionsNode.parentNode,
      homeNextSibling: productActionsNode.nextSibling,
      desktopParent: productActionsDesktopTarget,
    });
  }

  MoveMobileProductInfoNodes();
}

function MoveNodeBackHome(moveItem, currentNode) {
  if (moveItem.homeParent == null) return;

  if (
    moveItem.homeNextSibling != null &&
    moveItem.homeNextSibling.parentNode === moveItem.homeParent
  )
    moveItem.homeParent.insertBefore(
      currentNode,
      moveItem.homeNextSibling,
    );
  else moveItem.homeParent.appendChild(currentNode);
}

function MoveMobileProductInfoNodes() {
  if (
    mobileProductInfoTarget == null ||
    mobileProductInfoNodes.length == 0
  )
    return;

  const shouldMoveToMobile = mobileProductInfoBreakpoint.matches;

  for (const moveItem of mobileProductInfoNodes) {
    const currentNode = moveItem.node;

    if (currentNode == null) continue;

    if (moveItem.desktopParent != null) {
      if (shouldMoveToMobile) {
        MoveNodeBackHome(moveItem, currentNode);
      } else if (currentNode.parentNode !== moveItem.desktopParent) {
        moveItem.desktopParent.appendChild(currentNode);
      }
    } else if (shouldMoveToMobile) {
      if (currentNode.parentNode !== mobileProductInfoTarget)
        mobileProductInfoTarget.appendChild(currentNode);
    } else {
      MoveNodeBackHome(moveItem, currentNode);
    }

    if (currentNode.classList.contains('product-title-container'))
      currentNode.style.display = shouldMoveToMobile ? 'flex' : '';
  }
}

var fullScreenIsZoomed = false;
function handleClickImage(event) {
  //console.log('handleClickImage');
  if (!inFullScreenMode) {
    loadFullScreen();
    return;
  }

  if (!mediaGalleryLargeZoomLoaded) return;

  if (window.innerWidth < 600) {
    return;
  }

  const img = event.target;
  const imageParent = img.parentElement;
  const imageParentRect = imageParent.getBoundingClientRect();
  const imgRect = img.getBoundingClientRect();

  //console.log("imgRect:");
  //console.log(imgRect);

  const scaleX = img.naturalWidth / imgRect.width;
  const scaleY = img.naturalHeight / imgRect.height;

  const parentOffsetX = (imageParentRect.width - imgRect.width) / 2;
  const parentOffsetY = (imageParentRect.height - imgRect.height) / 2;

  const offsetX = 1 - (event.clientX - imgRect.left) / imgRect.width;
  const offsetY = 1 - (event.clientY - imgRect.top) / imgRect.height;

  //console.log('offsetX = ' + offsetX + ' | offsetY = ' + offsetY);

  const offsetTotalWidth = img.naturalWidth - imgRect.width;
  const offsetTotalHeight = img.naturalHeight - imgRect.height;

  //console.log("offsetTotalWidth = " + offsetTotalWidth);
  //console.log("offsetTotalHeight = " + offsetTotalHeight);

  const finalOffsetXMin = (img.naturalWidth - imgRect.width) * -1;
  const finalOffsetYMin = (img.naturalHeight - imgRect.height) * -1;

  //console.log("finalOffsetXMin = " + finalOffsetXMin);
  //console.log("finalOffsetYMin = " + finalOffsetYMin);

  const finalOffsetX =
    finalOffsetXMin + offsetX * offsetTotalWidth + parentOffsetX;
  const finalOffsetY =
    finalOffsetYMin + offsetY * offsetTotalHeight + parentOffsetY;

  //console.log("finalOffsetX = " + finalOffsetX);
  //console.log("finalOffsetY = " + finalOffsetY);

  if (!fullScreenIsZoomed) {
    //console.log('zoom on full screen image');
    //pdp-media-gallery-zoomBoxModal-zoomIn
    //console.log(event.target.classList);
    event.target.classList.add(
      'pdp-media-gallery-zoomBoxModal-zoomIn',
    );
    img.style.left = `${finalOffsetX}px`;
    img.style.top = `${finalOffsetY}px`;

    fullScreenIsZoomed = true;
    return;
  }

  if (fullScreenIsZoomed) {
    //console.log('reverse zoom on full screen image');
    event.target.classList.remove(
      'pdp-media-gallery-zoomBoxModal-zoomIn',
    );
    event.target.style.top = '0px';
    event.target.style.left = '0px';
    fullScreenIsZoomed = false;
  }
}

function handleTouchEndTapCloseButton(event) {
  closeFullScreen();
}

function handleClickCloseButton(event) {
  closeFullScreen();
}

function loadFullScreen() {
  if (inFullScreenMode) {
    return;
  }

  mediaGalleryElement.classList.add(
    'pdp-media-gallery-zoomBox-showModal',
  );
  mediaGalleryCloseFullScreenButton.style.display = 'block';

  var allMediaImages = document.querySelectorAll(
    '.pdp-media-gallery-v3-container  .mediaGalleryV3image[variantvalue="' +
      mediaCurrentVariantSku +
      '"]',
  );

  //console.log("allMediaImages.length = " + allMediaImages.length);

  mediaGalleryLargeImageContainer.style.width =
    allMediaImages.length * 100 + '%';

  inFullScreenMode = true;
  UpdateLargeImageShown();
  MediaGalleryUpdateResize();
}

function closeFullScreen() {
  mediaGalleryElement.classList.remove(
    'pdp-media-gallery-zoomBox-showModal',
  );
  mediaGalleryCloseFullScreenButton.style.display = 'none';
  mediaGalleryLargeImageContainer.style.width = 'auto';

  inFullScreenMode = false;
  UpdateLargeImageShown();
  MediaGalleryUpdateResize();
}

function MediaGalleryCloseZoomOffClick(event) {
  var isOutsideModal = true;

  //console.log(event.target);

  const targetElement = document.querySelector(
    '.pdp-media-gallery-zoomBox-showModal',
  );

  if (targetElement == null) return;

  if (targetElement.contains(event.target)) {
    isOutsideModal = false;
  }

  if (isOutsideModal) closeFullScreen();
}

function nwMediaUpdateZoomBox(event) {
  //console.log('nwMediaUpdateZoomBox mousemove X/Y ( '+event.pageX+'|'+event.pageY+')' );

  var mediaImageRect = currentMediaImage.getBoundingClientRect();

  var mediaImageX = mediaImageRect.width;
  var mediaImageY = mediaImageRect.height;

  var mouseImageX = event.pageX - mediaImageRect.x;
  var mouseImageY = event.pageY - mediaImageRect.y;

  var mousePercentX = mouseImageX / mediaImageX;
  var mousePercentY = mouseImageY / mediaImageY;

  //console.log("mousePercentX = " + mousePercentX + " | " + "mousePercentY = " + mousePercentY);

  //console.log('mediaImageRect width = ' + mediaImageRect.width);

  mediaZoomBoxElement.setAttribute('src', currentMediaImageBigSrc);
  var zoomBoxRect = mediaZoomBoxElement.getBoundingClientRect();
  //console.log('zoomBoxRect width = ' + zoomBoxRect.width);

  var zoomImagePosX = zoomBoxRect.width * mousePercentX;
  var zoomImagePosY = zoomBoxRect.height * mousePercentY;

  var zoomOffsetX =
    mediaZoomBoxElementContainer.getBoundingClientRect().width / 2;
  var zoomOffsetY =
    mediaZoomBoxElementContainer.getBoundingClientRect().height / 2;

  mediaZoomBoxElement.style.left =
    (zoomImagePosX - zoomOffsetX) * -1 + 'px';
  mediaZoomBoxElement.style.top =
    (zoomImagePosY - zoomOffsetY) * -1 + 'px';
}

function nwMediaUpdateZoomBoxLeave() {
  mediaZoomBoxElementContainer.style.display = 'none';
}

function nwMediaUpdateZoomBoxEnter() {
  mediaZoomBoxElementContainer.style.display = 'block';
}

function MediaGalleryV3FilterImages(variantSku) {
  //console.log('MediaGalleryV3FilterImages variantSku = ' + variantSku);
  allMediaImages = document.getElementsByClassName(
    'mediaGalleryV3image',
  );

  mediaCurrentVariantSku = variantSku;

  var targetVariantSkuClass = 'variantClass' + variantSku;

  currentMediaImageSet = false;
  var mediaPosition = 0;
  for (let i = 0; i < allMediaImages.length; i++) {
    var nextMediaElement = allMediaImages[i];

    if (nextMediaElement.classList.contains(targetVariantSkuClass)) {
      nextMediaElement.style.display = 'flex';

      if (nextMediaElement.classList.contains('product-image')) {
        nextMediaElement.setAttribute('mediaPosition', mediaPosition);
        mediaPosition++;
        if (!currentMediaImageSet)
          currentMediaImage = nextMediaElement;
      }
    } else {
      nextMediaElement.style.display = 'none';
    }
  }

  var elementWithSelection = document.body.querySelector(
    '.product-mini-image-selected',
  );
  if (elementWithSelection != null)
    document.body
      .querySelector('.product-mini-image-selected')
      .classList.remove('product-mini-image-selected');

  document.body
    .querySelector(
      ".pdp-media-gallery-v3-miniImages .mediaGalleryV3image[variantValue='" +
        variantSku +
        "']",
    )
    .classList.add('product-mini-image-selected');
  mediaGalleryMaxIndex = mediaPosition - 1;
  mediaGalleryLargeImageContainer.style.transform = 'none';
  mediaGalleryCurrentIndex = 0;

  UpdateLargeImageShown();
  //MediaGalleryUpdateResize();
}

function UpdateLargeImageWidthSize() {
  if (mediaCurrentVariantSku == null) return;
  //console.log('UpdateLargeImageWidthSize mediaCurrentVariantSku' + mediaCurrentVariantSku);
  mediaGalleryFirstActiveItem = document.body.querySelector(
    ".pdp-media-gallery-v3-container .mediaGalleryV3image[variantValue='" +
      mediaCurrentVariantSku +
      "']",
  );
  largeImageOffset = mediaGalleryFirstActiveItem.offsetWidth;
}

function ProductMiniImagesClicked(clickedElement) {
  UpdateLargeImageWidthSize();

  //console.log("ProductMiniImagesClicked clickedElement = " + clickedElement.classList);
  var nextVariantTarget = clickedElement.getAttribute('variantValue');
  mediaItemCode = clickedElement.getAttribute('mediaitem');
  //console.log("ProductMiniImagesClicked nextVariantTarget = " + nextVariantTarget);
  //console.log("ProductMiniImagesClicked mediaItemCode = " + mediaItemCode);

  if (
    document.body.querySelector('.product-mini-image-selected') !=
    null
  )
    document.body
      .querySelector('.product-mini-image-selected')
      .classList.remove('product-mini-image-selected');

  clickedElement.classList.add('product-mini-image-selected');

  var largeImage = document.body.querySelector(
    ".pdp-media-gallery-v3-container [mediaitem='" +
      mediaItemCode +
      "']",
  );
  var scrollPosition = largeImage.getAttribute('mediaPosition');
  MediaGalleryV3ScrollToImage(scrollPosition);
}

function ProductMiniImageSelectedUpdate() {
  var miniImageTarget = document.body.querySelector(
    ".product__media-wrapper .product-mini-image[mediaitem='" +
      mediaItemCode +
      "']",
  );

  console.log('mediaItemCode = ' + mediaItemCode);

  if (
    document.body.querySelector('.product-mini-image-selected') !=
    null
  )
    document.body
      .querySelector('.product-mini-image-selected')
      .classList.remove('product-mini-image-selected');

  miniImageTarget.classList.add('product-mini-image-selected');

  miniImageTarget.scrollIntoView({
    behavior: 'smooth',
    block: 'nearest',
    inline: 'center',
  });
}

function MediaControlButtonPressed(direction) {
  UpdateLargeImageWidthSize();

  mediaGalleryCurrentIndex += direction;

  UpdateMediaGalleryButtonState();

  //console.log('MediaControlButtonPressed mediaGalleryCurrentIndex = ' + mediaGalleryCurrentIndex + ' | mediaGalleryMaxIndex = ' + mediaGalleryMaxIndex);

  if (mediaGalleryCurrentIndex > mediaGalleryMaxIndex) {
    mediaGalleryCurrentIndex = mediaGalleryMaxIndex;
    return;
  }

  if (mediaGalleryCurrentIndex < 0) {
    mediaGalleryCurrentIndex = 0;
    return;
  }

  MediaGalleryV3ScrollToImage(mediaGalleryCurrentIndex);
  ProductMiniImageSelectedUpdate();
}

function MediaVideoOverlayClickAndPlay(targetVideoIdContainer) {
  document.body
    .querySelector(targetVideoIdContainer + ' video')
    .play();
  document.body.querySelector(
    targetVideoIdContainer + ' .video-media-play-overlay',
  ).style.display = 'none';
}

function MediaVideosReset() {
  const videos = document.querySelectorAll(
    '.pdp-media-gallery-v3-container media-gallery video',
  );

  videos.forEach((video, index) => {
    video.pause();
  });
}

function UpdateMediaGalleryButtonState() {
  /*
  if(mediaGalleryCurrentIndex >= mediaGalleryMaxIndex)
  {
    document.body.querySelector(".pdp-media-gallery-v3-controls-button-right").classList.add('disabled');
  }
  else
  {
    document.body.querySelector(".pdp-media-gallery-v3-controls-button-right").classList.remove('disabled');
  }

  if(mediaGalleryCurrentIndex <= 0)
  {
    document.body.querySelector(".pdp-media-gallery-v3-controls-button-left").classList.add('disabled');
  }
  else
  {
    document.body.querySelector(".pdp-media-gallery-v3-controls-button-left").classList.remove('disabled');
  }
    */
}

function MediaGalleryV3ScrollToImage(scrollToIndex, isInstant) {
  UpdateLargeImageWidthSize();

  if (scrollToIndex > mediaGalleryMaxIndex) {
    mediaGalleryCurrentIndex = mediaGalleryMaxIndex;
    return;
  }

  if (scrollToIndex < 0) {
    mediaGalleryCurrentIndex = 0;
    return;
  }

  //console.log("largeImageOffset  = " + largeImageOffset);
  var scrollPosition = scrollToIndex * largeImageOffset * -1;
  //console.log("scrollPosition = " + scrollPosition);
  if (!isInstant) {
    mediaGalleryLargeImageContainer.style.transitionDuration = '1s';
    mediaGalleryLargeImageContainer.style.transform =
      'translate(' + scrollPosition + 'px)';
  } else {
    //mediaGalleryLargeImageContainer.style.left = scrollPosition+'px';
    mediaGalleryLargeImageContainer.style.transitionDuration = '0s';
    mediaGalleryLargeImageContainer.style.transform =
      'translate(' + scrollPosition + 'px)';
  }
  mediaGalleryCurrentIndex = Number(scrollToIndex);

  CheckForZoomImageLoad();
  UpdateMediaGalleryButtonState();
  UpdateLargeImageShown();
  MediaVideosReset();
}

function UpdateLargeImageShown() {
  currentMediaImage = document.body.querySelector(
    ".pdp-media-gallery-v3-container [mediaposition='" +
      mediaGalleryCurrentIndex +
      "'][variantvalue='" +
      mediaCurrentVariantSku +
      "'] img",
  );

  if (currentMediaImage == null) return;

  mediaItemCode =
    currentMediaImage.parentElement.getAttribute('mediaitem');
  if (mediaItemCode == null)
    mediaItemCode =
      currentMediaImage.parentElement.parentElement.getAttribute(
        'mediaitem',
      );
  //console.log("mediaItemCode = " + mediaItemCode);
  currentMediaImageBigSrc = currentMediaImage.getAttribute('bigsrc');

  if (inFullScreenMode) {
    currentMediaImage.src = currentMediaImageBigSrc;
  } else {
    currentMediaImage.src =
      currentMediaImage.getAttribute('data-src');
  }

  //console.log('Loading Large Image');

  mediaGalleryLargeZoomLoaded = false;

  currentMediaImage.onload = function () {
    //console.log("Large Image Loaded");
    mediaGalleryLargeZoomLoaded = true;
  };

  //console.log('currentMediaImageBigSrc = ' + currentMediaImageBigSrc);
}

function MediaGalleryUpdateResize() {
  MediaGalleryV3ScrollToImage(mediaGalleryCurrentIndex, true);
  //MediaGalleryHeightAdjust();
  MediaGalleryStickyOffsetAdjust();
  MoveMobileProductInfoNodes();
}

function MediaGalleryStickyOffsetAdjust() {
  var headerRectData = document.body
    .querySelector('#shopify-section-header')
    .getBoundingClientRect();

  var targetMediaElement = document.body.querySelector(
    '.product__media-wrapper',
  );

  //targetMediaElement.style.top = headerRectData.bottom + 10 + "px";

  //console.log("headerRectData.bottom = " + headerRectData.bottom);
}

function MediaGalleryHeightAdjust() {
  var startMarkerRectData = document.body
    .querySelector('.nw-pdp-below-fold-v3-startMarker')
    .getBoundingClientRect();
  var productMediaRectData = document.body
    .querySelector('.shopify-section:has(.product__media-wrapper)')
    .getBoundingClientRect();

  //console.log("window.screen.width = " + window.innerWidth);

  if (window.innerWidth < 1200) {
    document.body.querySelector(
      '.shopify-section:has(.product__media-wrapper)',
    ).style.height = 'auto';
    return;
  }

  //console.log("startMarkerRectData.top = " + startMarkerRectData.top + "productMediaRectData.top = " + productMediaRectData.top);
  var heightCalculation =
    startMarkerRectData.top - productMediaRectData.top;
  //console.log("heightCalculation = " + heightCalculation);
  document.body.querySelector(
    '.shopify-section:has(.product__media-wrapper)',
  ).style.height = heightCalculation + 'px';

  //console.log("startMarkerRectData = " + startMarkerRectData);
}

function CheckForZoomImageLoad() {}

var startSwipeX;
var currentSwipeX;
var endSwipeX;
var swipeAmount = 0;
var twoFingerMovement = false;

var startSwipeY;
var currentSwipeY;
var endSwipeY;
var swipeAmountY = 0;

function swipeStartHandler(e) {
  startSwipeX = e.touches[0].clientX - swipeAmount;
  startSwipeY = e.touches[0].clientY - swipeAmountY;
  twoFingerMovement = false;
  if (e.touches.length > 1) twoFingerMovement = true;
  //console.log('startSwipeX ' + startSwipeX);

  /*
  if(!twoFingerMovement)
  {
    e.preventDefault();
    document.documentElement.classList.add('mediapage-lock');
  }
  else
  {
    document.documentElement.classList.remove('mediapage-lock');
  }
  */
}
function swipeCurrentHandler(e) {
  if (twoFingerMovement) return;

  //console.log("swipeAmount = " + swipeAmount);
  //console.log("swipeAmountY = " + swipeAmountY);

  if (Math.abs(swipeAmount) > Math.abs(swipeAmountY)) {
    e.preventDefault();
    document.documentElement.classList.add('mediapage-lock');
  }

  UpdateLargeImageWidthSize();

  var swipeDirection = -1;
  if (e.touches[0].clientX > currentSwipeX) {
    swipeDirection = 1;
  }

  currentSwipeX = e.touches[0].clientX;
  currentSwipeY = e.touches[0].clientY;

  //console.log('currentSwipeX ' + currentSwipeX);
  //swipeAmount += swipeDirection * swipeSpeed;

  swipeAmount = currentSwipeX - startSwipeX;
  swipeAmountY = currentSwipeY - startSwipeY;

  var swipeSensitiviy = 2;

  swipeAmount *= swipeSensitiviy;

  var scrollPosition =
    mediaGalleryCurrentIndex * largeImageOffset * -1 + swipeAmount;

  mediaGalleryMaxOffset =
    mediaGalleryMaxIndex * largeImageOffset * -1;

  if (scrollPosition > 0) {
    scrollPosition = 0;
  }

  if (scrollPosition < mediaGalleryMaxOffset) {
    scrollPosition = mediaGalleryMaxOffset;
  }

  mediaGalleryLargeImageContainer.style.transform =
    'translate(' + scrollPosition + 'px)';
  //updateCarousel();
}
function swipeEndHandler(e) {
  //mediaMasterBody.style.overflow = "auto";
  //document.documentElement.style.overflow = 'auto';

  endSwipeX = currentSwipeX;
  endSwipeY = currentSwipeY;
  //console.log('largeImageOffset ' + largeImageOffset);
  //console.log('swipeAmount' + swipeAmount);

  currentCard = Math.round(
    ((mediaGalleryCurrentIndex * largeImageOffset * -1 +
      swipeAmount) /
      largeImageOffset) *
      -1,
  );
  //console.log('currentCard ' + currentCard);

  swipeAmount = 0;
  swipeAmountY = 0;

  MediaGalleryV3ScrollToImage(currentCard);

  ProductMiniImageSelectedUpdate();

  setTimeout(function () {
    document.documentElement.classList.remove('mediapage-lock');
  }, 100);

  //updateCarousel();
}

addEventListener('DOMContentLoaded', (event) => {
  SetupMobileProductInfoMove();
  mobileProductInfoBreakpoint.addEventListener(
    'change',
    MoveMobileProductInfoNodes,
  );
  window.addEventListener('resize', MediaGalleryUpdateResize);
  window.addEventListener('scroll', MediaGalleryStickyOffsetAdjust);
  nwMediaGalleryWireUpEvents();
  window.addEventListener('click', function (event) {
    MediaGalleryCloseZoomOffClick(event);
  });
});
